// RigSentinel — Drilling Fluid Management (Phase RCE-3)
//
// RCE DERIVERS — pure functions that publish `mud.*` field paths to the
// Context Engine. Imported by `lib/rce/derivers.js` so there is no
// circular dependency between the resolver and the DMR document store.

import { resolveActiveMudProgram } from "./program";
import { MUD_PROPERTY_KEYS, pickLiveValue } from "./properties";
import { listFluidDocuments } from "./dmr";

function src(module, id, label) {
  return { module, id: id || "", label: label || "" };
}
const _isNonEmpty = (v) => v !== "" && v !== null && v !== undefined;
function safeList(fn) { try { return fn() || []; } catch { return []; } }

export function deriveMudField(field, ctx) {
  if (!ctx.wellId) return null;
  if (!field.startsWith("mud.")) return null;
  const program = resolveActiveMudProgram(ctx.wellId, ctx);

  if (field === "mud.programId") {
    if (!program) return null;
    return { value: program.id, confidence: "exact", source: src("mudProgram", program.id, program.name) };
  }
  if (field === "mud.fluidBasis") {
    if (!program || !_isNonEmpty(program.fluidBasis)) return null;
    return { value: program.fluidBasis, confidence: "exact", source: src("mudProgram", program.id, program.name) };
  }

  const key = field.slice("mud.".length);
  if (!MUD_PROPERTY_KEYS.includes(key)) return null;

  // Latest DMR for the well — its "current" reading wins.
  const dmrList = safeList(() => listFluidDocuments({ kind: "dailyMudReport", wellId: ctx.wellId }));
  if (dmrList.length > 0) {
    const dmr = dmrList[0];
    const v = dmr.payload?.properties?.[key];
    if (v && typeof v === "object") {
      const live = pickLiveValue(v);
      if (live.value !== "" && live.value != null) {
        return { value: live.value, confidence: "exact",
          source: src("dmr", dmr.id, `Daily Mud Report · ${live.source}`) };
      }
    }
  }

  // Otherwise the active Mud Program (first interval — RCE-3).
  if (program && Array.isArray(program.intervals)) {
    const iv = program.intervals[0];
    const tri = iv?.properties?.[key];
    if (tri) {
      const live = pickLiveValue(tri);
      if (live.value !== "" && live.value != null) {
        return { value: live.value, confidence: "derived",
          source: src("mudProgram", program.id, `${program.name} · ${live.source}`) };
      }
    }
  }
  return null;
}
